import { Navigation, Swiper } from 'swiper';
import { addZero } from '@/modules/functions';

export class SolutionSliders {
  solutions;
  imageSlider;
  textSlider;
  total;
  current;

  constructor() {}

  init() {
    this.solutions = document.querySelector('.home-solutions');
    if (!this.solutions) return;

    Swiper.use([Navigation]);
    this.initTextSlider();
    this.initImageSlider();
  }

  initTextSlider() {
    const loopedSlides = document.querySelectorAll(
      '.home-solutions-text-slider .swiper-slide'
    ).length;

    this.current = document.querySelector('.home-solutions-navigation-current');
    this.total = document.querySelector('.home-solutions-navigation-total');

    this.total.innerText = addZero(loopedSlides);

    this.current.innerText = addZero(1);

    this.textSlider = new Swiper('.home-solutions-text-slider', {
      loop: true,
      slidesPerView: 1,
      loopedSlides,
      allowTouchMove: false,
      navigation: {
        prevEl: '.home-solutions-navigation-prev',
        nextEl: '.home-solutions-navigation-next',
      },
      on: {
        slideChange: (swiper) => {
          this.current.innerText = addZero(swiper.realIndex + 1);
        },
      },
    });

    this.textSlider.updateSize();

    window.addEventListener('resize', () => {
      this.textSlider.updateSize();
    });
  }

  initImageSlider() {
    const loopedSlides = document.querySelectorAll(
      '.home-solutions-image-slider .swiper-slide'
    ).length;

    this.imageSlider = new Swiper('.home-solutions-image-slider', {
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: 30,
      loopedSlides,
      allowTouchMove: false,
      navigation: {
        prevEl: '.home-solutions-navigation-prev',
        nextEl: '.home-solutions-navigation-next',
      },
    });

    this.imageSlider.updateSize();

    window.addEventListener('resize', () => {
      this.imageSlider.updateSize();
    });
  }
}
